import React, { useState } from 'react';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { AmuraModel } from './AmuraModel';
import './AmuraWidget.css';

type Props = {
  className: string;
  title: string;
  description: string;
  avatar: string;
  link: string | undefined;
};

const AmuraWidget: React.FC<Props> = ({ className, title, description, avatar, link }) => {
  const [modalShow, setModalShow] = useState(false);
  

  return (
    <div className="amura-widget">
      <div className={`hoverable cursor-pointer`} role="button" onClick={() => setModalShow(true)}>
        <img src={toAbsoluteUrl('/media/partner/weight_loss_amura_futurisk_banner.png')} width="100%" alt='Amura Logo' className='card-p-5 shadow rounded-corners' />
      </div>
      <AmuraModel show={modalShow} handleClose={() => setModalShow(false)} />
    </div>
  );
};

export { AmuraWidget };
